import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IonicModule } from '@ionic/angular';
import { SharedModule } from '@shared/shared.module';
import { EstadoTramitePensionStepperComponent } from './components/estado-tramite-pension-stepper/estado-tramite-pension-stepper.component';
import { StatusCardComponent } from './components/status-card/status-card.component';
import { EstadoTramitePensionRoutingModule } from './estado-tramite-pension-routing.module';
import { CertificadoOfertasComponent } from './pages/certificado-ofertas/certificado-ofertas.component';
import { CertificadoSaldosComponent } from './pages/certificado-saldos/certificado-saldos.component';
import { EstadoTramitePensionHomeComponent } from './pages/estado-tramite-pension-home/estado-tramite-pension-home.component';
import { InicioTramitePensionComponent } from './pages/inicio-tramite-pension/inicio-tramite-pension.component';
import { ModalidadPensionComponent } from './pages/modalidad-pension/modalidad-pension.component';
import { PagoPensionComponent } from './pages/pago-pension/pago-pension.component';
import { ModalDescargaCertificadoComponent } from './components/modal-descarga-certificado/modal-descarga-certificado.component';
import { ModalDescargaCertificadoOfertasComponent } from './components/modal-descarga-certificado-ofertas/modal-descarga-certificado-ofertas.component';
import { DescargaCertificadoStepperComponent } from './components/descarga-certificado-stepper/descarga-certificado-stepper.component';

@NgModule({
  declarations: [
    EstadoTramitePensionHomeComponent,
    EstadoTramitePensionStepperComponent,
    StatusCardComponent,
    InicioTramitePensionComponent,
    CertificadoSaldosComponent,
    CertificadoOfertasComponent,
    ModalidadPensionComponent,
    PagoPensionComponent,
    ModalDescargaCertificadoComponent,
    ModalDescargaCertificadoOfertasComponent,
    DescargaCertificadoStepperComponent
  ],
  imports: [
    CommonModule,
    EstadoTramitePensionRoutingModule,
    IonicModule,
    SharedModule,
  ]
})
export class EstadoTramitePensionModule { }
